export const UPDATE_APP_DATA = "UPDATE_APP_DATA";
